import { RdPathLoader, RdDataSourcesLayout } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { useRdDataSourcesRedirect } from './hooks';

export const RdDataSources = (): React.ReactElement => (
  <RdPathLoader path={Path.RD_DATA_SOURCES} useRedirect={useRdDataSourcesRedirect}>
    <RdDataSourcesLayout />
  </RdPathLoader>
);
